/**
 * @ignore
 * Created by nerijussavickas on 12/30/16.
 */

'use strict';

const $ = require('dibs-jquery-shim');
const React = require('react');
const css = require('./RedirectedMessage-style.scss');

const SOLD_ITEM_COOKIE = 'soldItemTitle';
let soldItemTitle;

function RedirectedMessage() {
    if (!soldItemTitle && $.cookie(SOLD_ITEM_COOKIE)) {
        soldItemTitle = $.cookie(SOLD_ITEM_COOKIE);
        $.removeCookie('soldItemTitle', { path: '/' });
    }

    if (soldItemTitle) {
        return (
            <div className={css.message}>
                {soldItemTitle} <br/>
                is no longer available, we think you might like this item
            </div>
        );
    }

    return null;
}

module.exports = RedirectedMessage;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/RedirectedMessage/RedirectedMessage.jsx